import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from '../../common/icons/Icon';
import { Modal } from 'synfrastructure';
import AddForm from '../../common/forms/AddForm';
import {
  fetchCategories,
  addCategory,
  deleteCategory,
  reorderCategories,
} from '../actions';
import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import SortableListWrapper from '../../common/components/SortableListWrapper';

class CategoryListPage extends Component {
  static propTypes = {
    categories: PropTypes.object,
  };

  toggleAddCategoryModal = () => {
    this.setState({ addCategoryModalVisible: !this.state.addCategoryModalVisible });
  };

  constructor(props) {
    super(props);

    this.state = {
      addCategoryModalVisible: false,
    };
  }

  deleteCategory = category => {
    const { dispatch } = this.props;

    return dispatch(deleteCategory(category)).then((action) => {
      dispatch(fetchCategories());
    });
  }

  onAddCategorySubmit = values => {
    const { dispatch } = this.props;

    return dispatch(addCategory(values.name)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        dispatch(fetchCategories());
      }
    });
  };

  render() {
    const { categories, dispatch } = this.props;
    const {addCategoryModalVisible} = this.state;

    let renderedCategories = categories.get('data').map(category => {
      return (
        <li key={`category-${category.get('id')}`}>
          <Link className="admin-paper__list__link" to={`/library/${category.get('id')}`}>{category.get('name')} 
          </Link>
          <button onClick={() => this.deleteCategory(category.get('id'))}>
            <Icon icon={ category.get('active') ? "ToggleOn" : "ToggleOff" }/>
          </button>
        </li>
      );
    });

    let categoriesList = categories.get('data').toJS()

    return (
      <div className="admin-paper admin--library">
        <Modal isVisible={addCategoryModalVisible} onClose={this.toggleAddCategoryModal}>
            <AddForm
              entityType="Category"
              initialValues={{ name: null }}
              onSubmit={this.onAddCategorySubmit}
              onCancel={this.toggleAddCategoryModal}
            />
          </Modal>
          <SortableListWrapper
            items={categoriesList}
            onSave={items => {
              return dispatch(reorderCategories({ categoryIds: items.map(category => category.id) })).then(() => {
                dispatch(fetchCategories());
              });
            }}
            title="Library"
            topButtons={( <button onClick={this.toggleAddCategoryModal} className="button button--theme--plain">
              <Icon icon="Plus" /> Add Category
            </button>)}
          >
            <ul className="admin-paper__list">{renderedCategories}</ul>
          </SortableListWrapper>
      </div>
    );
  }
}

export default connect(state => ({
  categories: state.library.categories,
}))(CategoryListPage);



// WEBPACK FOOTER //
// ./src/library/categories/CategoryListPage.js